var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75609 0.244078C4.43065 -0.0813593 3.90301 -0.0813593 3.57757 0.244078L0.244241 3.57741C-0.0811968 3.90285 -0.0811968 4.43049 0.244241 4.75592L3.57757 8.08926C3.90301 8.41469 4.43065 8.41469 4.75609 8.08926C5.08152 7.76382 5.08152 7.23618 4.75609 6.91074L2.84534 5H12.5002C12.9604 5 13.3335 4.6269 13.3335 4.16667C13.3335 3.70643 12.9604 3.33333 12.5002 3.33333H2.84534L4.75609 1.42259C5.08152 1.09715 5.08152 0.569515 4.75609 0.244078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.5fc5901ab2787ce7d7d8cf71d92ccc22.svg";
export { ForwardRef as ReactComponent };